export enum Theme {
  SECOND_THIRD = 'theme-2-3',
  K1 = 'theme-k1',
  FOURTH_FIFTH = 'theme-4-5',
  MIDDLE_SCHOOL = 'theme-middle-school',
}
